import { ContenidoStatus } from './../../../../../common/contenido';
import { DestacadoActions, DestacadoActionTypes } from './destacado.actions';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Contenido } from 'src/common/contenido';

export interface DestacadoState extends EntityState<Contenido> {
	ready: boolean;
	maxQtyToLoad: number;
	status: ContenidoStatus;
	cleared: boolean;
}

export const destacadoAdapter: EntityAdapter<Contenido> = createEntityAdapter<Contenido>();

const initialDestacadoState: DestacadoState = destacadoAdapter.getInitialState({
	ready: true,
	maxQtyToLoad: 12,	// cantidad máxima de contenido destacado a cargar en el carousel
	status: null,
	cleared: false
});

export function destacadoReducer( state: DestacadoState = initialDestacadoState, action: DestacadoActions ): DestacadoState {
	let payload;
	let cleared: boolean;
	let status: ContenidoStatus;

	switch( action.type ) {
		case DestacadoActionTypes.DestacadoPageRequested:
			return { ...state, cleared: false, ready: false };
		case DestacadoActionTypes.DestacadoPageLoaded:
			payload = action["payload"];
			cleared = payload["cleared"];
			status = payload["status"];
			let destacado: Contenido[] = payload["destacado"];

			return destacadoAdapter.setAll( destacado, {
				...state,
				ready: true,
				status,
				cleared
			});
		case DestacadoActionTypes.DestacadoPageCancelled:
			payload = action["payload"];
			status = payload["status"];

			// Si status == null => hubo un problema con el status, dejo el state como está
			if( status != null && status.qty == 0 ) {
				state = destacadoAdapter.removeAll( state );
				state = { ...state, cleared: false, status };
			}

			return { ...state, ready: true };
		case DestacadoActionTypes.DestacadoPageRight:
			return { ...state, ready: true, cleared: false };
		default:
			return state;
	}
}

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = destacadoAdapter.getSelectors();